import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
import previewModal from '@/views/claim/demageManage/previewModal.vue';
import { getBase64, isImage, isVideo, isPDF } from '@/views/claim/demageManage/utils';
import { streamInfo } from '@/views/organization/staffManage/request';
import { downloadFileFun } from '@/utils/public';
export default {
  props: {
    pictureList: {
      type: Array,
      default() {
        return [];
      }
    },
    index: {
      type: Number,
      default: -1
    },
    index2: {
      type: Number,
      default: -1
    },
    uploadAccept: {
      type: String,
      default: ''
    },
    partsType: {
      type: String,
      default: ''
    },
    showRemoveIcon: {
      type: Boolean,
      default: true
    }
  },
  components: {
    previewModal
  },
  data() {
    return {
      action: uploadFile,
      fileList: [],
      picture: [],
      previewVisible: false,
      previewSrc: '',
      previewPDF: '',
      isPDFShow: false,
      isShow: '',
      currentPreviewIndex: 0,
      showPreviewIcon: true
    };
  },
  mounted() {
    if (this.pictureList.length != 0) {
      this.pictureList.map((i, index) => {
        let name = i.substring(i.lastIndexOf('/') + 1, i.lastIndexOf('.'));
        let format = i.substring(i.lastIndexOf('.')).toLowerCase();
        let obj = {
          status: 'done',
          uid: index + 1,
          url: i,
          format: format.slice(1),
          name: name + format
        };
        console.log(obj);
        this.fileList.push(obj);
      });
      if (this.showRemoveIcon) {
        this.showPreviewIcon = true;
      } else if (!this.showRemoveIcon && this.partsType == 'picture') {
        this.showPreviewIcon = true;
      } else if (!this.showRemoveIcon && this.partsType == 'enclosure') {
        this.showPreviewIcon = false;
      }
    }
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'done') {
        if (info.file.response.code != 200) {
          this.$message.error(info.file.response.message);
          this.fileList[this.fileList.length - 1].status = 'error';
        }
      }
      this.picture = [];
      this.fileList = info.fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
          this.picture.push(file.url);
        } else {
          this.picture.push(file.url);
        }
        return file;
      });
      this.$emit('pictureOk', this.picture, this.index, this.index2);
      console.log(this.fileList);
    },
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.fileList.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible = true;
    },
    handleDownload(obj) {
      const type2 = obj.format == 'pdf' ? 'application/pdf' : obj.format == 'png' ? 'image/png' : obj.format == 'jpg' ? 'image/jpg' : obj.format == 'jpeg' ? 'image/jpeg' : obj.format == 'gif' ? 'image/gif' : obj.format == 'jfif' ? 'image/jfif' : '';
      streamInfo({
        url: obj.url
      }).then(res => {
        console.log(res);
        downloadFileFun(res, type2, obj.name);
      });
    }
  }
};